import { COLORS } from '~/themes/common'

const style = (theme) => ({
  container: {
    [theme.breakpoints.up('lg')]: {
      borderTopWidth: 1,
      borderTopStyle: 'solid',
      borderTopColor: '#EAEAEA',
    },
  },
  galleryInfoLabel: {
    fontWeight: 500,
    fontSize: 14,
    color: '#3B4757',
    marginTop: 12,
  },
  galleryInfoValue: {
    fontSize: 14,
    color: '#3B4757',
    marginTop: 8,
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      '&:first-of-type > span:first-of-type': {
        marginTop: 0,
      },
    },
  },
  infoContainer: {
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      height: 'calc(100% - 12px)',
      overflowY: 'auto',
      marginTop: 12,
    },
    [theme.breakpoints.up('lg')]: {
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: '#EAEAEA',
      padding: 20,
      flex: 0.75,
    },
    '&::-webkit-scrollbar': {
      width: 5,
      height: 5,
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: 10,
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      backgroundColor: '#b4bfd9',
    },
  },
  metadataGrid: {
    [theme.breakpoints.down('md')]: {
      height: '100%',
      borderLeftWidth: 1,
      borderLeftStyle: 'solid',
      borderLeftColor: '#EAEAEA',
      paddingLeft: 12,
      paddingTop: 12,
    },
    [theme.breakpoints.up('lg')]: {
      flex: 1,
      overflow: 'hidden',
      // '&.galleryLayout': {
      //   height: 'calc(60vh - 300px)',
      // },
      // height: 'calc(70vh - 320px)',
    },
  },
  metadataContainer: {
    [theme.breakpoints.down('md')]: {
      height: '100%',
      overflowY: 'auto',
      paddingRight: 20,
    },
    [theme.breakpoints.up('lg')]: {
      overflowY: 'auto',
      height: '100%',
      padding: 20,
      boxSizing: 'border-box',
    },
  },
  formLabel: {
    textAlign: 'left',
    fontSize: 14,
    letterSpacing: 0,
    color: COLORS.palette.black,
    opacity: 1,
    position: 'relative',
    zIndex: 2,
    marginBottom: theme.spacing(1),
  },
  fileInfo: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: 10,
      marginTop: theme.spacing(1),
    },
  },
  fileData: {
    [theme.breakpoints.down('md')]: {
      marginTop: '8px !important',
    },
  },
})

export default style
